import Vue from "vue"
import VueRouter from "vue-router"
Vue.use(VueRouter)

import Layout from "@/layout"

/**
 * hidden:导航栏是否隐藏
 * alwaysShow:根节点是否显示
 * title: 页面标题
 * icon： 页面图标
 * affix：页面是否固定在标签栏
 */
export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index")
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login.vue"),
    hidden: true,
    meta: { title: "登录" }
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("@/views/logout.vue"),
    hidden: true,
    meta: { title: "登出..." }
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true
  },
  //{
  //  path: '/',
  //  component: Layout,
  //  component: () => import("../views/home/home.vue"),
  //  hidden: true
  //},
  {
    path: "/",
    redirect: "/home",
    component: Layout,
    //meta: { title: "首页1", icon: "home" },
    //alwaysShow: false,
    hidden: true,
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("../views/home/home.vue"),
        meta: {
          title: "首页",
          icon: "dot"
        }
      }
    ]
  }
]

//权限路由路径映射
export const mappingPath = {
  "/home": {
    path: "home",
    name: "home",
    component: () => import("../views/home/home"),
    meta: { title: "站点分布", icon: "dot" }
  },

  //统计分析3
  "/dev-data": {
    path: "/dev-data",
    redirect: "/dev-data/dev-online",
    component: Layout,
    meta: { title: "设备监测", icon: "dev-data" }
  },

  //订单管理
  "/order": {
    path: "/order",
    redirect: "/order/use-elec-log",
    component: Layout,
    meta: { title: "订单管理", icon: "record" },
    alwaysShow: true
  },

  "/month-report": {
    path: "month-report",
    name: "monthReport",
    component: () => import("../views/log/send-log.vue"),
    meta: { title: "月报表", icon: "dot" }
  },

  //日志管理
  "/log": {
    path: "/log",
    redirect: "/log/running-log",
    component: Layout,
    meta: { title: "事件记录", icon: "record" },
    alwaysShow: true
  },
  "/running-log": {
    path: "running-log",
    name: "RunningLog",
    component: () => import("../views/log/running-log.vue"),
    meta: { title: "设备运行日志", icon: "dot" }
  },
  "/send-log": {
    path: "send-log",
    name: "sendLog",
    component: () => import("../views/log/send-log.vue"),
    meta: { title: "短信推送日志", icon: "dot" }
  },

  "/charging-config-send-log": {
    path: "charging-config-send-log",
    name: "charging-config-send-log",
    component: () => import("../views/log/charging-config-send-log.vue"),
    meta: { title: "计费模型发送记录", icon: "dot" }
  },
  "/sms-send-log": {
    path: "sms-send-log",
    name: "sms-send-log",
    component: () => import("../views/log/sms-send-log.vue"),
    meta: { title: "短信发送记录", icon: "dot" }
  },
  "/dev-alarm-log": {
    path: "dev-alarm-log",
    name: "DevAlarmLog",
    component: () => import("../views/log/dev-alarm-log.vue"),
    meta: { title: "故障告警", icon: "dot" }
  },
  "/on-offline-log": {
    path: "on-offline-log",
    name: "OnOfflineLog",
    component: () => import("../views/log/on-offline-log.vue"),
    meta: { title: "上下线记录", icon: "dot" }
  },
  //设备管理5
  "/dev_archive": {
    path: "/dev_archive",
    name: "dev_archive",
    component: Layout,
    redirect: "/dev_archive/power-site-manage",
    meta: { title: "设备管理", icon: "dev_archive" }
  },
  "/dev-ips-plan": {
    path: "dev-ips-plan",
    name: "DevSsPlan",
    component: () => import("../views/dev_archive/power-site-ips-plan.vue"),
    meta: { title: "设备切IP计划", icon: "dot" }
  },
  "/triplet-info": {
    path: "triplet-info",
    name: "tripletInfo",
    component: () => import("../views/dev_archive/triplet-info.vue"),
    meta: { title: "三元信息", icon: "dot" }
  },
  "/power-site-manage": {
    path: "power-site-manage",
    name: "powersitemanage",
    component: () => import("../views/dev_archive/power-site-manage.vue"),
    meta: { title: "站点管理", icon: "dot" }
  },

  "/charge-pile-manage": {
    path: "charge-pile-manage",
    name: "chargepilemanage",
    component: () => import("../views/dev_archive/charge-pile-manage.vue"),
    meta: { title: "充电桩管理", icon: "dot" }
  },
  "/charge-gun-manage": {
    path: "charge-gun-manage",
    name: "chargegunmanage",
    component: () => import("../views/dev_archive/charge-gun-manage.vue"),
    meta: { title: "充电枪管理", icon: "dot" }
  },
  "/upgrade-package": {
    path: "upgrade-package",
    name: "upgradePackage",
    component: () => import("../views/dev_archive/upgrade-package.vue"),
    meta: { title: "设备升级包", icon: "dot" }
  },

  //运行监控
  "/dev-online": {
    path: "dev-online",
    name: "DevOnline",
    component: () => import("../views/dev_data/dev-online.vue"),
    meta: { title: "设备状态", icon: "dot" }
  },
  "/error-order": {
    path: "error-order",
    name: "ErrorOrder",
    component: () => import("../views/dev_data/error-order.vue"),
    meta: { title: "异常订单", icon: "dot" }
  },

  "/order-settle-push": {
    path: "order-settle-push",
    name: "OrderSettlePush",
    component: () => import("../views/dev_data/order-settle-push.vue"),
    meta: { title: "结算监控", icon: "dot" }
  },

  "/dev-charge-order": {
    path: "dev-charge-order",
    name: "DevChargeOrder",
    component: () => import("../views/dev_data/dev-charge-order.vue"),
    meta: { title: "充电订单", icon: "dot" }
  },

  //系统管理8
  "/user": {
    path: "/user",
    redirect: "/user/user-manager",
    component: Layout,
    meta: { title: "系统管理", icon: "setting" }
  },
  "/group-manage": {
    path: "groupManage",
    name: "GroupManage",
    component: () => import("../views/user/group-manage.vue"),
    meta: { title: "集团管理", icon: "dot" }
  },
  "/user-manager": {
    path: "user-manager",
    name: "UserManager",
    component: () => import("../views/user/user-manager.vue"),
    meta: { title: "用户管理", icon: "dot" }
  },
  "/role-manager": {
    path: "role-manager",
    name: "RoleManager",
    component: () => import("../views/user/role-manager.vue"),
    meta: { title: "角色管理", icon: "dot" }
  },
  "/menus-manager": {
    path: "menus-manager",
    name: "MenusManager",
    component: () => import("../views/user/menus-manager.vue"),
    meta: { title: "菜单管理", icon: "dot" }
  },

  "/system-log": {
    path: "system-log",
    name: "SystemLog",
    component: () => import("../views/user/system-log.vue"),
    meta: { title: "系统日志", icon: "dot" }
  },
  "/jng_wx_user": {
    path: "jng_wx_user",
    name: "Jngwxuser",
    component: () => import("../views/user/jng_wx_user.vue"),
    meta: { title: "微信用户", icon: "dot" }
  }
}

export const asyncRoutes = []

const createRouter = () =>
  new VueRouter({
    // mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
